

<div class="">
    <div class="flex justify-between items-center">
        <span class="font-bold text-gray flex gap-3">
             <fa-icon [icon]="faPerson"></fa-icon> Warehouse Personnel's
        </span>


        <button *ngxPermissionsOnly="addPermission" (click)="onAdd()" mat-raised-button color="primary" style="background-color: #005590;">
            <mat-icon>add</mat-icon>
            Assign Personnel's
        </button>
    </div>
</div>

<div class="">
    <app-paginated-data-table
            [query]="query"
            [resetTable]="refresh"
            [tableConfigurations]="tableConfiguration"
            [permissions]="permissions"
            (customAction)="onCustomAction($event)"
            [actionButtons]="actionButtons"
            [additionalVariables]="additionalVariables"
            [mapFunction]="mapFunction"
            (getData)="getData($event)"
            [upsertAction]="upsertAction"
            [deleteAction]="removeAction"
            >
    </app-paginated-data-table>
</div>
